import React, { useEffect, useState } from "react";
import store1 from "../Assets/store1.jpeg";
import phone from "../Assets/phone.gif";
import onlineshopping from "../Assets/onlineshopping.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons/faAngleUp";
import "../Styles/View.css";

function View() {
  const [goUp, setGoUp] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const onPageScroll = () => {
      setGoUp(window.scrollY > 200);
    };
    window.addEventListener("scroll", onPageScroll);

    return () => window.removeEventListener("scroll", onPageScroll);
  }, []);

  const handleCatalogueClick = (e) => {
    e.preventDefault();

    const eventId = crypto.randomUUID();
    window.sendCAPIEvent("CatalogueClick", eventId);

    setTimeout(() => {
      window.location.href =
        "https://www.capvital.fr/catalogues/catalogue_mad_balagnemedicalservices.html";
    }, 400);
  };

  const handleContactClick = () => {
    const eventId = crypto.randomUUID();
    window.sendCAPIEvent("Contact", eventId);

    window.location.href = "tel:0495307856";
  };

  return (
    <div className="section-container">
      <div className="View-section">
        <img
  className="background-image"
  src={process.env.PUBLIC_URL + "/background1.jpg"}
  alt="background"
  fetchPriority="high"
  loading="eager"
  decoding="async"
  width="1035"
  height="2048"
/>

        <div className="text-section">
          <p className="text-headline">Balagne Medical Service</p>
          <h2 className="text-title">Spécialiste en matériel médical</h2>
          <p className="text-descritpion">
            Balagne Medical Service est une entreprise fondée en 2005.
            Notre équipe est spécialisée dans la location et la vente de matériel médical.
            Nous contribuons au bien-être des personnes âgées, à mobilité réduite,
            ou victimes d’accidents de la vie, en leur proposant un aménagement adapté.
          </p>

          <button
            className="text-appointment-btn"
            type="button"
            onClick={handleContactClick}
          >
            <img src={phone} alt="phone icon" width="24" height="24" fetchPriority="high" />
            Contact
          </button>

          <button
            className="text-appointment-btn"
            type="button"
            onClick={handleCatalogueClick}
          >
            <img src={onlineshopping} alt="onlineshopping" width="24" height="24" fetchPriority="high" />
            Boutique
          </button>
        </div>

        <div className="View-image-section">
          <img
            className="View-image1"
            src={store1}
            alt="store1"
            fetchPriority="high"
            decoding="async"
            width="1600"
            height="1200"
            style={{ width: "100%", height: "auto" }}
          />
        </div>
      </div>

      <div
        onClick={scrollToTop}
        className={`scroll-up ${goUp ? "show-scroll" : ""}`}
      >
        <FontAwesomeIcon icon={faAngleUp} />
      </div>
    </div>
  );
}

export default View;
